import { useDrag } from '@use-gesture/react';
import { damp, dampE, exp } from 'maath/easing';
import { LogEase } from '@/helpers/LogEase';
import { useAppStore } from '@/stores/app';
import { ECS } from '../state';

const positionEntities = ECS.world.with('position', 'three');
const spriteEntities = ECS.world.with('sprite', 'three');

export const SystemRender = ({}) => {
  const gl = useThree((state) => state.gl);
  const domElement = gl.domElement;

  useFrame((state, delta) => {
    // POSITION
    for (const entity of positionEntities) {
      entity.three.position.x = entity.position.x;
      entity.three.position.y = entity.position.y;
      entity.three.position.z = entity.position.z ?? 0;
    }

    // SPRITESHEET
    // for (const entity of spriteEntities) {
    //   entity.sprite.current.progress = entity.sprite;
    // }
  });

  return null;
};
